import type { InstructorT } from './index'
import createApiThunk from '../../../ApplicationFactory'

export const getInstructors = createApiThunk<InstructorT>('getInstructors', {
  url: '/api/users/instructors/',
  method: 'GET'
})
